// src/app/services/mbrs/validation-taxonomy.util.ts
import { ValidationSchema } from '../../models/validation-schema.model';

/** Extract "MFRS" / "MPERS" from a schema's `taxonomy` field (e.g. "FS-MFRS"). */
export function extractTaxonomyFromSchema(schema: ValidationSchema | null | undefined): 'MFRS' | 'MPERS' | null {
  if (!schema || !schema.taxonomy) {
    return null;
  }
  const taxonomyField = schema.taxonomy as string;
  if (taxonomyField.includes('MFRS')) {
    return 'MFRS';
  }
  if (taxonomyField.includes('MPERS')) {
    return 'MPERS';
  }
  // Intentionally mirrors the legacy combined validation-warning service diagnostic — keep behaviour identical during the split.
  console.warn(`⚠️ Unknown taxonomy format: ${taxonomyField}`);
  return null;
}
